import { CCol, CImg, CRow } from "@coreui/react"
import Close from "assets/icons/Maintenance close.svg"
import warning from "assets/icons/Maintenance warning.svg"
import { useTheme } from "components/common/Context/ThemeContext"
import CMSTypography, {
  StandardTypographyTypes
} from "components/common/typography/CMSTypography"
import { getMaintenanceSchedule } from "extensions/usoc/api/admin"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import useSWR from "swr"
import {
  dateTagHelper,
  parseDateFromTimezone,
  useExtension,
  useUserAuth
} from "utils"

const ServiceNowBanner = ({ setShowServiceBanner }) => {
  const theme = useTheme()
  const auth = useUserAuth()
  const extension = useExtension()
  const host = extension?.config?.env?.clientApiGateway?.URL

  const { data: maintenanceList, error: maintenanceResError } = useSWR(
    () => "/get_maintenance_schedule",
    () => getMaintenanceSchedule({ auth, host }),
    { suspense: true }
  )

  if (maintenanceResError) {
    console.log(maintenanceResError)
  }

  const [maintenanceData, setMaintenanceData] = useState()

  useEffect(() => {
    const today = new Date()
    const filteredList = maintenanceList?.data.filter(
      (d) =>
        today >= parseDateFromTimezone(d.startDate) &&
        today <= parseDateFromTimezone(d.endDate) &&
        d.deleted === "F"
    )

    setMaintenanceData(filteredList)
    if (filteredList.length !== 0) {
      setShowServiceBanner(true)
    } else {
      setShowServiceBanner(false)
    }
  }, [maintenanceList, setShowServiceBanner])

  return (
    <CRow className="mx-2 py-1 mtnc-banner-container rounded">
      <CImg src={warning} alt="warning symbol" className="ml-3" />
      <CCol className="d-flex flex-column justify-content-center">
        {maintenanceData?.map((data, index) => {
          return (
            <CMSTypography
              key={"flash-message-" + index}
              type={StandardTypographyTypes.cardContent}
              color={theme.whiteColor}
            >
              {dateTagHelper(
                data.message,
                parseDateFromTimezone(data.startDate),
                parseDateFromTimezone(data.endDate)
              )}
            </CMSTypography>
          )
        })}
      </CCol>
      <CImg
        src={Close}
        alt="close"
        className="mr-3 cursor-pointer"
        onClick={() => setShowServiceBanner(false)}
      />
    </CRow>
  )
}

ServiceNowBanner.propTypes = {
  setShowServiceBanner: PropTypes.func
}

export default ServiceNowBanner
